import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const getExportEmployeeData = createAsyncThunk(
  "candidate/exportEmployeeData",
  async (payload, { rejectWithValue }) => {
    console.log("enter");
    try {
      const response = await axiosPrivate.post(
        `${api.getExportEmployeeData}`,
        payload,
        {
          responseType: "blob",
        },
      );
      if (response.status === 200) {
        toast.success("Data Exported successfully!", {
          className: "toast-success-custom",
        });
      }
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "employees.xlsx";
      if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, "");
        }
      } else {
        console.warn("Content-Disposition header is missing or not exposed.");
      }

      const blob = new Blob([response.data], {
        type:
          response.headers["content-type"] ||
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      const errorText = await error?.response?.data?.text();
      const parseErrMsg = errorText ? JSON.parse(errorText) : {};
      toast.error(parseErrMsg?.message || "Failed to export data!", {
        className: "toast-error-custom",
      });
      return rejectWithValue(
        parseErrMsg?.message || "Unable to connect to server!",
      );
    }
  },
);

const getExportEmployeeDataSlice = createSlice({
  name: "exportEmployeeData",
  initialState: {
    exportEmployeeData: null,
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getExportEmployeeData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getExportEmployeeData.fulfilled, (state) => {
        state.status = "succeeded";
        state.loading = false;
        state.exportEmployeeData = null;
      })
      .addCase(getExportEmployeeData.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getExportEmployeeDataSlice.reducer;
